import React from "react";
import PropTypes from "prop-types";
import LogoImg from "../../assets/BidPro_Logo_Light.png";
import styles from "./LogoLink.module.css";

const LogoLink = ({ onClick }) => {
  return (
    <div>
      <img src={LogoImg} id={styles.logo} alt="Bidpro Logo" onClick={onClick} />
    </div>
  );
};

LogoLink.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default LogoLink;
